import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { ProfileType } from "../../types/userTypes";
import { checkTokenValidation } from "../auth/tokenReq";

type createCEPAdminReqPropType = {
  firstName: string;
  lastName: string;
  email: string;
  PhoneCountryCode: number;
  mobile: string;
  TimeZone: string
  designation: string;
};

export const createCEPAdminReq = async (data: createCEPAdminReqPropType) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": cepAdminRequest->createCEPAdminReq " + t
    );
  try {
    await checkTokenValidation();
    const body = data;

    const res = await authAxios.post(`${ApiKey.newCEPAdminKey}`, body);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = {};
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const getCEPsListReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": cepAdminRequest->createCEPAdminReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.getCEPsListKey}`);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const cepData = resData?.CEP || [];
    const _data = cepData?.map((item: any) => ({
      user: {
        userID: item?.user?.userID || "",
        email: item?.user?.email || "",
        mobileNumber: item?.user?.mobileNumber || "",
      },
      employee: {
        employeeID: item?.employee?.employeeID || "",
        firstName: item?.employee?.firstName || "",
        lastName: item?.employee?.lastName || "",
        designation: item?.employee?.designation || "",
        workLocation: item?.employee?.workLocation || "",
        createdAt: item?.employee?.createdAt || "",
        updatedAt: item?.employee?.updatedAt || "",
        companyID: item?.employee?.companyID || "",
        userID: item?.employee?.userID || "",
        CEPPartnerID: item?.employee?.CEPPartnerID || "",
      },
    }));
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const deleteCEPuserReq = async (params: { userID: number }) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": cepAdminRequest->deleteCEPuserReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.post(
      `${ApiKey.deleteCEPbyIdKey}/${params?.userID}`
    );
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = null;
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const updateCEPuserReq = async (
  params: { userID: number },
  data: {
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
  }
) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": cepAdminRequest->deleteCEPuserReq " + t
    );
  try {
    await checkTokenValidation();
    const body = data;

    const res = await authAxios.post(
      `${ApiKey.updateCEPbyIdKey}/${params?.userID}`,
      body
    );
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = null;
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
